module.exports = __webpack_public_path__ + "img/silver.dc198e6d.svg";